import { render, staticRenderFns } from "./sxgcjxsjzlb.vue?vue&type=template&id=0ae269df&scoped=true"
import script from "./sxgcjxsjzlb.vue?vue&type=script&lang=js"
export * from "./sxgcjxsjzlb.vue?vue&type=script&lang=js"
import style0 from "./sxgcjxsjzlb.vue?vue&type=style&index=0&id=0ae269df&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae269df",
  null
  
)

export default component.exports